import { useResource } from '@landsbankinn/l16n';
import { Box, Col } from '@landsbankinn/ui-kit';
import { type ReactNode } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { Header as MobileHeader } from '../Layout/Mobile/Header';
import { Loading } from '../Loading';
import { res } from './Consent.res';
import { ErrorBox } from './Shared/ErrorBox';
import { InfoBox } from './Shared/InfoBox';
import { OverlayHeader } from './Shared/OverlayHeader';
import { useConsentClientContext } from './State/consentClientState';
import { getLocalizedString } from './utils';

export function Body(props: { children?: ReactNode }) {
  const [consentClient] = useConsentClientContext();
  const { isMobile } = useScreenSize();
  const { r } = useResource();
  const isError = consentClient.error;

  const currentView = consentClient.views[consentClient.currentViewIndex];
  const isListView =
    currentView?.type === 'listview' || currentView?.type === 'listviewselect';

  const DeskTopHeader = () => {
    if (isListView) return null;

    const description = getLocalizedString(
      'description',
      consentClient.localization,
    );

    return (
      <Box paddingBottom="72">
        <OverlayHeader
          subHero={description}
          title={getLocalizedString('title', consentClient.localization)}
          background={consentClient.hero ? 'backgroundAlt' : undefined}
        />
      </Box>
    );
  };

  const alertTitle = getLocalizedString('alert', consentClient.localization);
  const alertDescription = getLocalizedString(
    'alert_description',
    consentClient.localization,
  );

  return (
    <Col minHeight={isMobile ? '100vh' : '100%'} grow="1">
      {!isMobile && alertTitle && (
        <Box paddingBottom="36">
          <InfoBox title={alertTitle} description={alertDescription} />
        </Box>
      )}
      {isMobile && <MobileHeader title="Landsbankinn" />}
      {consentClient.isLoading && (
        <Col
          grow="1"
          mainAxisAlignment="center"
          paddingHorizontal="40"
          paddingBottom="80"
        >
          <Loading title={r(res.loadingTitle)} description="" />
        </Col>
      )}
      {!consentClient.isLoading && (
        <Col grow="1">
          {isMobile && (
            <InfoBox title={alertTitle} description={alertDescription} />
          )}
          {isError && <ErrorBox />}
          {!isError && (
            <Col grow="1">
              {!isMobile && <DeskTopHeader />}
              <Col grow="1">{props.children}</Col>
            </Col>
          )}
        </Col>
      )}
    </Col>
  );
}
